import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  DevNote,
  FormFieldSet,
  PageHeader,
  PageTitle,
  showToast,
  ToolTip,
  useFormHandler,
} from "../../../../components";
import {
  consultantNameOptions,
  vendorTypeOptions,
} from "../../../../assets/data/projectData";
import { fetchLatestUiid } from "../../../../redux/slices/employee/employeeApi";
import { useDispatch, useSelector } from "react-redux";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import {
  addNewVendorStart,
  addToDraft,
  getVendorOneStart,
  setVendorProfile,
  updateVendorStart,
} from "../../../../redux/slices/vendor/vendorSlice";
import useDropdownData from "../../../../hooks/useDropdownData";
import { v4 as uuidv4 } from "uuid";
import { validate as uuidValidate, version as uuidVersion } from "uuid";
import { filterEmptyValues } from "../../../../utils/filterEmptyValues";
import { debounce } from "../../../../utils";

const BusinessInformation = ({
  setActiveTab,
  isEditable,
  editVendor = "",
  vendorId,
}) => {
  const containerRef = useRef(null);
  const vendorProfileUiid = useSelector(
    (state) => state.vendor.vendorProfileUiid,
  );
  const vendorDetails = useSelector(
    (state) => state.vendor.currentVendor.vendorDetails,
  );
  const [latestUiid, setLatestUiid] = useState(null);
  const [IdsToPull, setIdsToPull] = useState({
    vendor: [],
  });
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      vendorType: "",
      vendorId: "",
      businessName: "",
      emailAddress: [],
      federalId: "",
      // contactNumberCountryCode: "",
      contactNumber: [],
      businessEstablished: "",
      consultantName: "",
      dbaBusiness: "",
      legalName: "",
      Website: "",
      name: [
        {
          id: uuidv4(),
          name: "",
          type: "",
          email: [],
          mobileNumber: [],
        },
      ],
    },
    {
      vendorType: { type: "select", required: true },
      federalId: { type: "alphanumeric", required: true },
      emailAddress: { type: "email", required: true, multiple: true },
      businessName: { type: "text", required: true },
    },
  );

  const dispatch = useDispatch();
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;

  //handle change for sync with store-prefill
  useEffect(() => {
    // if (vendorProfileUiid) {
    if (vendorProfileUiid || Object.keys(vendorDetails).length > 0) {
      handleChange("vendorType", vendorDetails?.vendorType || "");
      handleChange("vendorId", vendorProfileUiid || "");
      handleChange(
        "businessName",
        vendorDetails.businessName ? vendorDetails.businessName : "" || "",
      );
      handleChange("dbaBusiness", vendorDetails.dbaName || "");
      handleChange("emailAddress", vendorDetails.email || []);
      handleChange("federalId", `${vendorDetails?.federalId}` || "");
      // handleChange(
      //   "contactNumberCountryCode",
      //   vendorDetails?.phone?.code || ""
      // );
      const phoneData = vendorDetails?.phone ?? [];
      const lastCode =
        phoneData.length > 0 ? phoneData[phoneData.length - 1].code : "+91";

      const updateData = [...phoneData, { code: lastCode, number: "" }];

      handleChange("contactNumber", updateData);
      // handleChange("contactNumber", vendorDetails?.phone?.number || "");

      // handleChange("contactNumber", vendorDetails?.phone?.[0]?.number || "");
      handleChange("businessEstablished", vendorDetails?.estYear || "");
      handleChange("consultantName", vendorDetails?.consultantName || "");
      // handleChange("legalName", vendorDetails?.legalName || "");
      handleChange("Website", vendorDetails?.website || "");
      // handleChange(
      //   "name",
      //   vendorDetails?.roleContacts?.length > 0
      //     ? vendorDetails.roleContacts.map((a) => {
      //         return {
      //           id: a._id,
      //           type: a.role,
      //           name: a.name,
      //           email: a.email,
      //           mobileNumber: a.phone?.[0]?.number || "",
      //           mobileNumberCountryCode: a.phone?.[0]?.code || "",
      //         };
      //       })
      //     : [
      //         {
      //           id: uuidv4(),
      //           name: "",
      //           type: "",
      //           email: [],
      //           mobileNumber: "",
      //           mobileNumberCountryCode: "",
      //         },
      //       ]
      // );
      handleChange(
        "name",
        vendorDetails?.roleContacts?.length > 0
          ? vendorDetails.roleContacts.map((a) => {
              const phoneData = a?.phone ?? [];
              const lastCode =
                phoneData.length > 0
                  ? phoneData[phoneData.length - 1].code
                  : "+91";

              return {
                id: a._id,
                type: a.role,
                name: a.name,
                email: a.email,
                mobileNumber: [...phoneData, { code: lastCode, number: "" }],
              };
            })
          : [
              {
                id: uuidv4(),
                type: "",
                email: [],
                mobileNumber: [{ code: "+91", number: "" }],
              },
            ],
      );
    }
    // }, [vendorDetails, vendorProfileUiid]);
    // }, [vendorProfileUiid, Object.keys(vendorDetails).length]);
  }, [vendorProfileUiid]);
  useEffect(() => {
    dispatch(
      getVendorOneStart({
        vendorUiid: vendorId,
        // retrieve: `uiid vendorType dbaName phone businessName email  federalId contact estYear  consultantName  legalName  website generalInfo`,
        retrieve: `uiid vendorType roleContacts dbaName phone businessName email  federalId estYear  consultantName  legalName  website generalInfo`,
      }),
    );
    const fetchLatestUiidData = async () => {
      try {
        const response = await fetchLatestUiid("vendors");
        // setLatestUiid((prev) => (prev = response.data.data.count + 1)); // Modified this line
        const count = response?.data?.data?.count;
        if (typeof count === "number") {
          setLatestUiid(count + 1);
        } else {
          setLatestUiid(1);
        }
        handleChange("vendorId", response.data.data.count + 1);
      } catch (error) {
        showToast("Error fetching latest UIID", "error", 5000);
      }
    };
    if (!vendorId) {
      if (vendorProfileUiid) {
        setLatestUiid(vendorProfileUiid);
      } else {
        fetchLatestUiidData();
      }
    }
    if (vendorId) {
      setLatestUiid(vendorId);
    }
  }, [vendorId]);

  // const handleBack = () => {
  //   setTimeout(() => {
  //     // Move to back tab
  //     setActiveTab((prev) => prev - 1)
  //   }, 500)
  // }
  const {
    data: allSelectEmployeeListOptions,
    searchValue: allSelectEmployeeSearch,
    handleSearch: handleSelectEmployeeSearch,
    resetSearch: resetAllSelectEmployeeSearch,
    handleScroll: handleAllSelectEmployeeScroll,
  } = useDropdownData("employeesConsultantFullNames", 10, {}, {});
  const handleSave = () => {
    const isValid = validateAllFields();
    try {
      if (isValid) {
        const prepareSubmissionData = {
          _skipFlatten: ["email", "phone", "roleContacts"],
          addedBy: loginUserUiid,
          businessName: formData.businessName,
          vendorType: formData.vendorType,
          email: formData.emailAddress,
          phone: Array.isArray(formData.contactNumber)
            ? formData.contactNumber.filter(
                (data) => data?.code && data?.number,
              )
            : [],
          federalId: formData.federalId,
          estYear: Number(formData.businessEstablished),
          dbaName: formData.dbaBusiness || "",
          consultantName: Number(formData.consultantName),
          // legalName: formData.legalName,
          website: formData.Website,
          roleContacts: formData.name
            .filter((role) => {
              if (!vendorProfileUiid) return true;
              return !uuidValidate(role.id) || uuidVersion(role.id) !== 4;
            })
            .map((role) => ({
              role: role?.type?.value || "",
              name: role.name,
              email: role?.email?.filter((email) => email) || [],
              phone: Array.isArray(role.mobileNumber)
                ? role.mobileNumber.filter((data) => data?.code && data?.number)
                : [],
            })),
        };
        // if (formData.contactNumber && formData.contactNumberCountryCode) {
        //   prepareSubmissionData.phone.push({
        //     code: formData.contactNumberCountryCode,
        //     number: Number(formData.contactNumber),
        //   });
        // }
        let newContacts = formData.name.filter(
          // (role) => uuidValidate(role.id) && uuidVersion(role.id) === 4
          (role) => uuidValidate(role.id),
        );
        let submissionData = filterEmptyValues(prepareSubmissionData);
        if (vendorProfileUiid) {
          // console.log("patching data:::::::::");
          // console.log("formData in client busnies info", formData);
          dispatch(
            updateVendorStart({
              uiid: latestUiid,
              coll: `Vendor`,
              payload: [{ type: "SET", value: prepareSubmissionData }],
              onSuccess: () => {
                setActiveTab((prev) => prev + 1);
              },
            }),
          );
          dispatch(setVendorProfile(prepareSubmissionData));
        } else {
          // console.log("posting data::");
          dispatch(addNewVendorStart(submissionData));
          dispatch(setVendorProfile(submissionData));
          setActiveTab((prev) => prev + 1);
        }
      } else {
        console.log("Please fix the errors before submitting.");
      }
    } catch (error) {
      console.error("error in save", error);
      showToast(
        `${error.message || "Failed to add new employee"}`,
        "error",
        5000,
      );
    }
  };

  const handleDraft = useMemo(
    () =>
      debounce((value) => {
        dispatch(
          // addToDraft({
          //   [field]: value ? value : "",
          // })
          addToDraft({ ...value }),
        );
      }, 1000),
    [dispatch],
  );
  useEffect(() => {
    let vendorData = {
      vendorType: formData.vendorType,
      businessName: formData.businessName,
      dbaName: formData.dbaBusiness || "",
      email: formData.emailAddress,
      federalId: formData.federalId,
      phone: Array.isArray(formData.contactNumber)
        ? formData.contactNumber.filter((data) => data?.code && data?.number)
        : [],
      estYear: Number(formData.businessEstablished),
      consultantName: Number(formData.consultantName),
      // legalName: formData.legalName,
      website: formData.Website,
      roleContacts: formData?.name?.map((role) => ({
        role: role?.type?.value || "",
        name: role.name,
        email: role?.email?.filter?.((email) => email) || [],
        phone: Array.isArray(role.mobileNumber)
          ? role.mobileNumber.filter((data) => data?.code && data?.number)
          : [],
      })),
    };
    // if (vendorProfileUiid || Object.keys(vendorDetails).length > 0) {
    handleDraft(vendorData);
    // }
  }, [formData]);

  return (
    <div className="flex flex-col w-full h-full px-8 py-3 overflow-auto rounded">
      <DevNote>
        <h5>latestUiid: {latestUiid}</h5>
        <h5>vendorProfileUiid: {vendorProfileUiid}</h5>
      </DevNote>
      <div className="mb-8">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle
                title={"Business Information"}
                icon={"badge"}
                tag="h5"
              />
            </div>
          }
          RightSection={
            <>
              {/* <Button
                title="Back"
                size="sm"
                icon={"arrow_left_alt"}
                onClick={handleBack}
              /> */}
              {isEditable && editVendor && (
                <Button title="Save" size="sm" onClick={handleSave} />
              )}
            </>
          }
        />
      </div>
      <div className="grid xs:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 max-w-7xl">
        <div>
          <FormFieldSet
            type="select"
            title={"Vendor Type"}
            placeholder="Select Vendor Type"
            options={vendorTypeOptions}
            value={formData.vendorType}
            onChange={(value) => handleChange("vendorType", value)}
            error={errors.vendorType}
            required
            disabled={!isEditable}
          />
        </div>
        <div>
          <FormFieldSet
            type="text"
            title={"Vendor ID"}
            placeholder="Enter Client ID"
            // value={formData.employeeId}
            value={latestUiid}
            //onChange={(value) => handleChange("clientId", value)}
            error={errors.vendorId}
            //required
            disabled
          />
          {/* <FormFieldSet
            type="text"
            title={"Vendor ID"}
            placeholder="VEN-001"
            value={formData.vendorId}
            onChange={(value) => handleChange("vendorId", value)}
            error={errors.vendorId}
          /> */}
        </div>
        <div>
          <FormFieldSet
            type="text"
            title={"Legal Business Name"}
            placeholder="Enter Legal Business Name"
            value={formData.businessName}
            onChange={(value) => handleChange("businessName", value)}
            error={errors.businessName}
            disabled={!isEditable}
          />
        </div>
        {/* <div>
          <FormFieldSet
            type="email"
            title={"Email Address"}
            placeholder="Enter Email Address"
            value={formData.emailAddress}
            onChange={(value) => handleChange("emailAddress", value)}
            error={errors.emailAddress}
            disabled={!isEditable}
            multiple
          />
            
        </div> */}
        <div>
          <FormFieldSet
            type="text"
            title={"DBA Business Name"}
            placeholder="Enter DBA Business Name"
            value={formData.dbaBusiness}
            onChange={(value) => handleChange("dbaBusiness", value)}
            error={errors.dbaBusiness}
            disabled={!isEditable}
            multiple
          />
        </div>
        <div>
          <FormFieldSet
            type="text"
            title={"Federal ID"}
            placeholder="Enter Federal ID"
            value={formData.federalId}
            onChange={(value) => handleChange("federalId", value)}
            error={errors.federalId}
            disabled={!isEditable}
            alphanumeric
          />
        </div>
        <div>
          <FormFieldSet
            // type="text"
            type="datepicker"
            title={"Business Established"}
            placeholder="Select Date"
            value={formData.businessEstablished}
            onChange={(value) => handleChange("businessEstablished", value)}
            error={errors.businessEstablished}
            disabled={!isEditable}
            showDropdown={false}
          />
        </div>
        <div>
          <FormFieldSet
            type="text"
            title={"Website"}
            // placeholder="Enter Website"
            placeholder="https://www.domain.com/"
            value={formData.Website}
            onChange={(value) => handleChange("Website", value)}
            error={errors.Website}
            disabled={!isEditable}
          />
        </div>
        {/* <div>
          <FormFieldSet
            type="text"
            title={"Business Name"}
            placeholder="Enter Business Name"
            value={formData.businessName}
            onChange={(value) => handleChange("businessName", value)}
            error={errors.businessName}
            disabled={!isEditable}
          />
        </div> */}
        <div>
          <FormFieldSet
            type="email"
            title={
              <ToolTip
                size="sm"
                description={"Please type and enter"}
                color="primary"
              >
                <span className="mr-1">Email</span>
              </ToolTip>
            }
            placeholder="Enter Email Address"
            value={formData.emailAddress}
            onChange={(value) => handleChange("emailAddress", value)}
            error={errors.emailAddress}
            disabled={!isEditable}
            multiple
          />
        </div>

        <div>
          {/* <FormFieldSet
            type="phone"
            title={"Contact Number"}
            placeholder="Enter Contact Number"
            value={formData.contactNumber}
            code={formData.contactNumberCountryCode}
            onChange={(fullValue, details) => {
              handleChange("contactNumber", details.number);
              handleChange("contactNumberCountryCode", details.countryCode);
            }}
            error={errors.contactNumber}
            disabled={!isEditable}
          /> */}
          <FormFieldSet
            type={"phoneNew"}
            title={
              <ToolTip
                size="sm"
                description={"Please type and enter"}
                color="primary"
              >
                <span className="mr-1">Contact Number</span>
              </ToolTip>
            }
            placeholder="Enter Contact Numbers"
            values={formData.contactNumber || []}
            multiple
            onChange={(e) => {
              handleChange("contactNumber", e);
            }}
            error={errors.contactNumber}
          />
        </div>
        {/* 17-06-2025 mail to be hide*/}
        {/* <div>
          <FormFieldSet
            type="select"
            title={"Consultant Name"}
            placeholder="Select Consultant Name"
            // options={consultantNameOptions}
            options={allSelectEmployeeListOptions}
            keyname="employees"
            value={formData.consultantName}
            onChange={(value) => handleChange("consultantName", value)}
            error={errors.consultantName}
            showSearch
            searchValue={allSelectEmployeeSearch}
            onClose={resetAllSelectEmployeeSearch}
            refData={containerRef}
            onSearch={handleSelectEmployeeSearch}
            handleScroll={() => handleAllSelectEmployeeScroll(containerRef)}
            disabled={!isEditable}
          />
        </div> */}
      </div>
      {/* <div className="grid grid-cols-4 gap-x-4 max-w-7xl mt-6">
        <div>
          <FormFieldSet
            type="text"
            title={"Name"}
            placeholder="Enter name"
            value={formData.name}
            onChange={(value) => handleChange("name", value)}
            error={errors.name}
            disabled={!isEditable}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            title={"Select HR Name"}
            placeholder="Enter HR Name"
            value={formData.type}
            onChange={(value) => handleChange("type", value)}
            error={errors.type}
            disabled={!isEditable}
            showButton
            showSearch
          />
        </div>
        <div>
          <FormFieldSet
            type="text"
            title={"Email"}
            placeholder="Enter Email"
            value={formData.email}
            onChange={(value) => handleChange("email", value)}
            error={errors.email}
            disabled={!isEditable}
          />
        </div>
        <div className="flex gap-3">
          <div className="w-[85%]">
            <FormFieldSet
              type="select"
              title={"Phone Number"}
              placeholder="Enter Phone Number"
              value={formData.mobileNumber}
              onChange={(value) => handleChange("mobileNumber", value)}
              error={errors.mobileNumber}
              disabled={!isEditable}
            />
          </div>

          <div className="w-[15%] mt-5">
            <div className="mt-3 flex gap-2">
              <Button type="icon" icon="add" size="xs" color="black" />
              <Button type="icon" icon="remove" size="xs" color="danger" />
            </div>
          </div>
        </div>
      </div> */}
      <div className="grid grid-cols-1 gap-y-4 max-w-7xl mt-6">
        {formData.name.map((hr, index) => (
          <div key={hr.id} className="grid grid-cols-3 xl:grid-cols-[repeat(4,1fr)_30px] gap-x-4">
            <div>
              <FormFieldSet
                type="roleType"
                title={"Type"}
                placeholder="Type"
                value={hr.type}
                onChange={(value) => handleChange(`name[${index}].type`, value)}
                error={errors?.name?.[index]?.type}
                disabled={!isEditable}
                // disabled={true}
                showButton
                showSearch
              />
            </div>
            <div>
              <FormFieldSet
                type="text"
                title={"Name"}
                placeholder="Enter name"
                value={hr.name}
                onChange={(value) => handleChange(`name[${index}].name`, value)}
                error={errors?.name?.[index]?.name}
                disabled={!isEditable}
                // disabled={true}
              />
            </div>

            <div>
              <FormFieldSet
                // type="text"
                type="email"
                title={
                  <ToolTip
                    size="sm"
                    description={"Please type and enter"}
                    color="primary"
                  >
                    <span className="mr-1">Email</span>
                  </ToolTip>
                }
                placeholder="Enter Email"
                value={hr.email}
                onChange={(value) =>
                  handleChange(`name[${index}].email`, value)
                }
                disabled={!isEditable}
                multiple
              // disabled={true}
              />
            </div>
            <div>
              <FormFieldSet
                type={"phoneNew"}
                title={
                  <ToolTip
                    size="sm"
                    description={"Please type and enter"}
                    color="primary"
                  >
                    <span className="mr-1">Phone Numbers</span>
                  </ToolTip>
                }
                placeholder="Enter Contact Numbers"
                values={hr.mobileNumber || []}
                multiple
                onChange={(e) => {
                  handleChange(`name[${index}].mobileNumber`, e);
                }}
                error={errors?.name?.[index]?.mobileNumber}
              />
            </div>
            <div className="flex items-center">
              <div className="flex gap-2 mt-5 lg:mt-6 items-center">
                <Button
                  type="icon"
                  icon="add"
                  size="xs"
                  color="black"
                  onClick={() => {
                    if (formData.name.length > 4) return;
                    const newHR = {
                      id: uuidv4(),
                      name: "",
                      type: "",
                      email: "",
                      mobileNumber: "",
                    };
                    handleChange("name", [...formData.name, newHR]);
                  }}
                />
                {console.log("IDsToPull", IdsToPull)}
                <Button
                  type="icon"
                  icon="remove"
                  size="xs"
                  color="danger"
                  disabled={formData.name.length === 1}
                  onClick={() => {
                    const isUiid = uuidValidate(formData.name[index].id);
                    if (!isUiid) {
                      setIdsToPull((prev) => ({
                        vendor: [...prev.vendor, formData.name[index].id],
                      }));
                    }
                    const updatedHRDetails = formData.name.filter(
                      (_, i) => i !== index,
                    );
                    handleChange("name", updatedHRDetails);
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BusinessInformation;
